<template>
  <div class="date-select">
    <input class="Wdate" id="d4321" v-model="sDate.fDate" @focus="ResetLable" onFocus="WdatePicker({maxDate:'#F{$dp.$D(\'d4322\',{d:0});}'})" />
    <b>~</b>
    <input class="Wdate" id="d4322" v-model="sDate.aDate" @focus="ResetLable" onFocus="WdatePicker({minDate:'#F{$dp.$D(\'d4321\',{d:0});}'})"/>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
              sDate:{
                fDate:'',
                aDate:'',
              },
            }
        },
        mounted() {
          document.getElementsByClassName('Wdate')[0]
        },
        methods: {
          getDate(){
            this.sDate.fDate = document.getElementsByClassName('Wdate')[0].value;
            this.sDate.aDate = document.getElementsByClassName('Wdate')[1].value;
            this.$emit('query',this.sDate);
          },
          setDate(Date){
            this.sDate.fDate = Date.fDate;
            this.sDate.aDate = Date.aDate;
            //console.log(val)
          },
          ResetLable(){
            this.$emit('ResetLable');
          }
        },
        watch:{
          /*sDate(){
            this.ResetLable();
          },
          deep:true*/
        },
        created() {
        }
    }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">

  .date-select
    display:inline-block
    position:relative
    input
      position:relative
      text-indent:6px

</style>



// WEBPACK FOOTER //
// selectDate.vue?09c349f0